import { Input } from "@/components/ui/input";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MOBILE_REGEX = /^[6-9]\d{9}$/;

export const validateStep2 = (formData) => {
  const errors = {};
  if (!formData.primary_mobile) errors.primary_mobile = "Required";
  else if (!MOBILE_REGEX.test(formData.primary_mobile))
    errors.primary_mobile = "Enter 10-digit mobile starting 6/7/8/9";
  if (formData.alternate_mobile && !MOBILE_REGEX.test(formData.alternate_mobile))
    errors.alternate_mobile = "Enter 10-digit mobile";
  if (formData.whatsapp_number && !MOBILE_REGEX.test(formData.whatsapp_number))
    errors.whatsapp_number = "Enter 10-digit mobile";
  if (!formData.email) errors.email = "Required";
  else if (!EMAIL_REGEX.test(formData.email)) errors.email = "Invalid email";
  return errors;
};

export default function Step2Contact({ formData, setFormData, errors }) {
  const set = (k, v) => setFormData((p) => ({ ...p, [k]: v }));

  return (
    <div className="space-y-6" data-testid="step2-contact">
      <div>
        <h2 className="text-lg font-bold text-slate-800">Contact Details</h2>
        <p className="text-sm text-slate-500">
          How we reach the partner for daily operations
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field
          label="Primary Mobile"
          required
          error={errors.primary_mobile}
          testid="primary-mobile"
        >
          <PhoneInput
            value={formData.primary_mobile || ""}
            onChange={(v) => set("primary_mobile", v)}
            onBlur={() => {
              if (formData.primary_mobile && !formData.whatsapp_number) {
                set("whatsapp_number", formData.primary_mobile);
              }
            }}
            testid="primary-mobile-input"
          />
        </Field>

        <Field
          label="Alternate Mobile"
          error={errors.alternate_mobile}
          testid="alternate-mobile"
        >
          <PhoneInput
            value={formData.alternate_mobile || ""}
            onChange={(v) => set("alternate_mobile", v)}
            testid="alternate-mobile-input"
          />
        </Field>

        <Field
          label="WhatsApp Number"
          helper="Auto-filled from Primary Mobile — edit if different"
          error={errors.whatsapp_number}
          testid="whatsapp-number"
        >
          <PhoneInput
            value={formData.whatsapp_number || ""}
            onChange={(v) => set("whatsapp_number", v)}
            testid="whatsapp-input"
          />
        </Field>

        <Field label="Email" required error={errors.email} testid="email">
          <Input
            type="email"
            value={formData.email || ""}
            onChange={(e) => set("email", e.target.value)}
            placeholder="owner@business.com"
            data-testid="email-input"
          />
        </Field>
      </div>

      {/* Divider */}
      <div className="flex items-center gap-3 pt-2">
        <div className="h-px bg-slate-200 flex-1" />
        <span className="text-xs uppercase tracking-wider text-slate-500 font-semibold">
          Point of Contact (if different from owner)
        </span>
        <div className="h-px bg-slate-200 flex-1" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field label="POC Name" testid="poc-name">
          <Input
            value={formData.poc_name || ""}
            onChange={(e) => set("poc_name", e.target.value)}
            placeholder="Operations head"
            data-testid="poc-name-input"
          />
        </Field>

        <Field
          label="POC Mobile"
          helper="Daily operations contact person"
          testid="poc-mobile"
        >
          <PhoneInput
            value={formData.poc_mobile || ""}
            onChange={(v) => set("poc_mobile", v)}
            testid="poc-mobile-input"
          />
        </Field>
      </div>
    </div>
  );
}

function PhoneInput({ value, onChange, onBlur, testid }) {
  return (
    <div className="flex">
      <span className="inline-flex items-center px-3 rounded-l border border-r-0 border-slate-300 bg-slate-50 text-slate-600 text-sm font-medium">
        +91
      </span>
      <Input
        type="tel"
        maxLength={10}
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, ""))}
        onBlur={onBlur}
        className="rounded-l-none"
        placeholder="9876543210"
        data-testid={testid}
      />
    </div>
  );
}

function Field({ label, required, helper, error, children, testid }) {
  return (
    <div data-testid={`field-${testid}`}>
      <label className="block text-xs font-semibold text-slate-600 uppercase tracking-wide">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="mt-1.5">{children}</div>
      {helper && !error && (
        <p className="text-[11px] text-slate-400 mt-1">{helper}</p>
      )}
      {error && <p className="text-[11px] text-red-600 mt-1">{error}</p>}
    </div>
  );
}
